import { CurrentUserService } from 'services/currentUser';
import * as angular from 'angular';
import * as policiesPage from 'pages/policies';
import { NavigationService } from 'services/navigation';
import { isActive } from 'utilities/policyInfosHelper';
import { isMobile } from 'utilities/devices';
import { FlagshipService } from 'services/flagship';
import { ModalService } from 'common/source/services/modal';

const module = angular.module('policies-state', [policiesPage.module.name]);

const resolve = {
    policyInfos: function(currentUserService: CurrentUserService) {
        'ngInject';

        return currentUserService.getDisplayOrderedCustomerPolicyInfos();
    }
};

const template = '<policies-page policy-infos="policyInfos"></policies-page>';

interface PoliciesPageContainerScope extends angular.IScope {
    policyInfos: Array<CustomerPolicyInfo>;
}

const controller = function(
    $scope: PoliciesPageContainerScope,
    policyInfos: Array<CustomerPolicyInfo>,
    navigationService: NavigationService,
    flagshipService: FlagshipService,
    $window: angular.IWindowService,
    modalService: ModalService
) {
    'ngInject';


    const loadMobileAppDownloadModal = () => {
        const isMobileDevice: boolean = isMobile();

        if (isMobileDevice && $window.localStorage.getItem('hasSeenMobileAppDownloadModal') === null) {
            $window.localStorage.setItem('hasSeenMobileAppDownloadModal', 'true');
            modalService.openUncloseableModal('mobile-app-download-login-modal');
        }
    };


    $scope.policyInfos = policyInfos;

    if ($scope.policyInfos.length === 1 && isActive($scope.policyInfos[0])) {
        navigationService.toPolicyOverviewPage('1' as RoutePolicyIndex);
    } else {
        if (flagshipService.getFeatureFlagStatus() === 'FeatureFlagStatus:Ready') {
            if (flagshipService.getFlag('mobileAppDownloadLoginModal') === true) {
                loadMobileAppDownloadModal();
            }
        } else {
            $scope.$on('FeatureFlagStatus:Ready', () => {
                if (flagshipService.getFlag('mobileAppDownloadLoginModal') === true) {
                    loadMobileAppDownloadModal();
                }
            });
        }
    }
};

export { module, template, controller, resolve };
